import { z } from 'zod'

export const CustomerChangeStrategySchema = z.enum(['clear', 'copy', 'from_new_customer', 'keep'])

export const CustomerChangeSectionKeySchema = z.enum([
  'contact',
  'locations',
  'payment_terms',
  'pod_requirement',
  'rate',
  'references',
])

export const CustomerChangeSectionSchema = z.object({
  default: CustomerChangeStrategySchema,
  key: CustomerChangeSectionKeySchema,
  options: CustomerChangeStrategySchema.array(),
})

export const CustomerChangeWarningSchema = z.object({
  code: z.string(),
  company: z.string().nullish(),
  documents: z.string().array().default([]),
})

export const GetCustomerChangeOptionsSchema = z.object({
  sections: CustomerChangeSectionSchema.array(),
  warnings: CustomerChangeWarningSchema.array().default([]),
})

export const CustomerChangeDiffRowSchema = z.object({
  after: z.string().nullish(),
  before: z.string().nullish(),
  key: z.string(),
  label: z.string(),
  note: z.string().nullish(),
})

export const CustomerChangeLocationPlanSchema = z.object({
  action: z.enum(['create', 'reuse']),
  location_id: z.number(),
  name: z.string().nullish(),
})

export const GetCustomerChangePreviewSchema = z.object({
  changes: CustomerChangeDiffRowSchema.array().default([]),
  locations: CustomerChangeLocationPlanSchema.array().default([]),
  warnings: CustomerChangeWarningSchema.array().default([]),
})

const CustomerChangeChoiceSchema = z.object({ strategy: CustomerChangeStrategySchema })

export const GetEndCustomerPreviewSchema = z.object({
  company: z.object({ id: z.number(), title: z.string().nullish() }).nullish(),
  locations: CustomerChangeLocationPlanSchema.array().default([]),
})

export const CustomerChangeInputSchema = z.object({
  company_id: z.number(),
  contact: CustomerChangeChoiceSchema.optional(),
  locations: CustomerChangeChoiceSchema.optional(),
  payment_terms: CustomerChangeChoiceSchema.optional(),
  pod_requirement: CustomerChangeChoiceSchema.optional(),
  rate: CustomerChangeChoiceSchema.optional(),
  references: CustomerChangeChoiceSchema.optional(),
})

export const AssignCustomerInputSchema = CustomerChangeInputSchema.extend({
  acknowledged: z.string().array().optional(),
})

export type AssignCustomerInput = z.input<typeof AssignCustomerInputSchema>
export type CustomerChangeDiffRow = z.output<typeof CustomerChangeDiffRowSchema>
export type CustomerChangeInput = z.input<typeof CustomerChangeInputSchema>
export type CustomerChangeLocationPlan = z.output<typeof CustomerChangeLocationPlanSchema>
export type CustomerChangeOptions = z.output<typeof GetCustomerChangeOptionsSchema>
export type CustomerChangePreview = z.output<typeof GetCustomerChangePreviewSchema>
export type CustomerChangeSection = z.output<typeof CustomerChangeSectionSchema>
export type CustomerChangeSectionKey = z.output<typeof CustomerChangeSectionKeySchema>
export type CustomerChangeStrategy = z.output<typeof CustomerChangeStrategySchema>
export type CustomerChangeWarning = z.output<typeof CustomerChangeWarningSchema>
export type EndCustomerPreview = z.output<typeof GetEndCustomerPreviewSchema>
